import React from 'react'
import { Box, LinearProgress, ListItem, ListItemIcon, ListItemText, Skeleton, Stack, Typography } from '@mui/material'

const InvoiceAccordionSummarySkeleton = () => {
  return (
    <Box width="100%">
      <LinearProgress sx={{ position: 'absolute', top: -5, left: 0, width: '100%' }} />
      <ListItem
        secondaryAction={
          <Stack direction="row" alignItems="center" gap={1}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Stack>
        }
      >
        <ListItemIcon sx={{ mr: 7 }}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Skeleton variant="circular" width={24} height={24} />
          </Stack>
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={
            <Typography variant="h4" fontWeight={600}>
              <Skeleton variant="text" width={350} />
            </Typography>
          }
          secondary={
            <Typography variant="subtitle2">
              <Skeleton variant="text" width={200} />
            </Typography>
          }
        />
      </ListItem>
    </Box>
  )
}

InvoiceAccordionSummarySkeleton.propTypes = {}

export default InvoiceAccordionSummarySkeleton
